/* jshint esversion: 6 */

export default class FancyboxGalleryDirective {

	constructor() {
		this.restrict = 'A';
	}

	link(scope, element, attributes, controller) {
		// Intercetta i click sui pulsanti `data-fancybox-trigger` prima che
		// arrivino al gestore delegato di Fancybox sul document: quel gestore
		// passa il pulsante come `$trigger`, con la conseguenza che Fancybox
		// usa l'immagine dentro il pulsante (es. icon-gallery.svg) come
		// thumbnail — animando l'apertura da quell'icona ingrandita e
		// impedendo il ritrovamento dei pin (che sono siblings dell'immagine
		// della gallery, non dell'icona del pulsante).
		element.on('click.fancybox-gallery-trigger', '[data-fancybox-trigger]', function (e) {
			e.preventDefault();
			e.stopPropagation();
			var name = $(this).attr('data-fancybox-trigger');
			var idx = parseInt($(this).attr('data-fancybox-index') || '0', 10) || 0;
			$('[data-fancybox="' + name + '"]').eq(idx).trigger('click.fb-start');
		});

		$('.fancybox', element).fancybox({
			closeBtn: false,
			hash: false, // Disabilita la modifica dell'URL
			touch: false,
			zoom: false,
			baseClass: 'fancybox-custom', // Aggiungi una classe base per identificare il fancybox
			afterLoad: function () {
				var $pin = this.$thumb ? this.$thumb.siblings('.label') : $();

				if (!$pin.length) {
					return;
				}

				var _this = this;
				$pin.each(function (i, el) {
					_this.$content.append($(el).clone()[0]);
				});
			},
			afterClose: function () {
				history.pushState("", document.title, window.location.pathname + window.location.search);
			}
		}).addClass('fancyboxed');
		$('.anchor-link').on('click', function (e) {
			// e.preventDefault();

			var target = this.hash,
				$target = $(target);

			$('html, body').stop().animate({
				'scrollTop': $target.offset().top - 100
			}, 900, 'swing', function () {
			});

			// console.log(window.location);

			return false;
		});

	}

	static factory() {
		return new FancyboxGalleryDirective();
	}

}

FancyboxGalleryDirective.factory.$inject = [];
